// HOC = Higher Order Component
const aux = props => props.children;

export default aux;



// WEBPACK FOOTER //
// ./src/hoc/ReactAux.js